var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCouponIcon(_ref, svgRef) {
  var {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.89062 9.1875C9.89062 10.3525 10.8351 11.2969 12 11.2969C13.1649 11.2969 14.1094 10.3525 14.1094 9.1875C14.1094 8.02249 13.1649 7.07812 12 7.07812C10.8351 7.07812 9.89062 8.02249 9.89062 9.1875ZM12 9.89062C11.6117 9.89062 11.2969 9.57583 11.2969 9.1875C11.2969 8.79917 11.6117 8.48438 12 8.48438C12.3883 8.48438 12.7031 8.79917 12.7031 9.1875C12.7031 9.57583 12.3883 9.89062 12 9.89062Z",
    fill: "#039F8D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.5156 14.8125C15.5156 15.9775 16.4601 16.9219 17.625 16.9219C18.7899 16.9219 19.7344 15.9775 19.7344 14.8125C19.7344 13.6475 18.7899 12.7031 17.625 12.7031C16.4601 12.7031 15.5156 13.6475 15.5156 14.8125ZM17.625 15.5156C17.2367 15.5156 16.9219 15.2008 16.9219 14.8125C16.9219 14.4242 17.2367 14.1094 17.625 14.1094C18.0133 14.1094 18.3281 14.4242 18.3281 14.8125C18.3281 15.2008 18.0133 15.5156 17.625 15.5156Z",
    fill: "#039F8D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 15.8069L18.6194 9.1875L17.625 8.19313L11.0056 14.8125L12 15.8069Z",
    fill: "#039F8D"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 19.7344H24V12.7031H23.2969C22.9086 12.7031 22.5937 12.3883 22.5937 12C22.5937 11.6117 22.9086 11.2969 23.2969 11.2969H24V4.26562H0V11.2969H0.703125C1.09144 11.2969 1.40625 11.6117 1.40625 12C1.40625 12.3883 1.09144 12.7031 0.703125 12.7031H0V19.7344ZM1.40625 18.3281V13.9893C2.22551 13.6998 2.8125 12.9185 2.8125 12C2.8125 11.0815 2.22551 10.3002 1.40625 10.0107V5.67188H22.5937V10.0107C21.7745 10.3002 21.1875 11.0815 21.1875 12C21.1875 12.9185 21.7745 13.6998 22.5937 13.9893V18.3281H1.40625Z",
    fill: "#039F8D"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.07812 19.7344V16.9219H5.67187V19.7344H7.07812Z",
    fill: "#039F8D"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.07812 15.5156V12.7031H5.67187V15.5156H7.07812Z",
    fill: "#039F8D"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.07812 11.2969V8.48438H5.67187V11.2969H7.07812Z",
    fill: "#039F8D"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.07812 7.07812V4.26562H5.67187V7.07812H7.07812Z",
    fill: "#039F8D"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCouponIcon);
export default __webpack_public_path__ + "static/media/coupon_icon.0f26ed625365f374fc9cf42436783e2f.svg";
export { ForwardRef as ReactComponent };